import {
  useState,
  useEffect,
} from "react"

const onboardingStorageKey = "sm-onboarding-source"

function setIsOnboardingSource(isOnboardingSource: boolean) {
  if (isOnboardingSource) {
    localStorage.setItem(
      onboardingStorageKey,
      `${isOnboardingSource}`,
    )
  } else {
    localStorage.removeItem(onboardingStorageKey)
  }
}

function getIsOnboardingSource(): boolean {
  const value = localStorage.getItem(onboardingStorageKey)
  return value === "true"
}

// this is only used for redirecting the user back to the onboarding flow
// after adding a dexcom or tandem data source during onboarding
// otherwise the user will end up on the settings/data_source page
export function useIsOnboardingSource() {
  const state = useState<boolean>(getIsOnboardingSource())

  const value = state[0]

  useEffect(
    () => {
      setIsOnboardingSource(value)
    },
    [value],
  )

  return state
}
